import React from 'react';
import styled from 'styled-components';
import { QRCode } from 'react-qrcode-logo';
// import {RoundButton} from '../../../libs/components/RoundButton';
// import icons from '../../Icons/icons';
import {EmailShareButton,FacebookShareButton,WhatsappShareButton,TelegramShareButton} from 'react-share';
import {
    EmailIcon,
    FacebookIcon,
    WhatsappIcon,
    TelegramIcon
  } from "react-share";


const ShareContainer = styled.div`
  background-image:linear-gradient(20deg, #373434 0%, #14140f 100%);
  padding-bottom: 25px;
  width: 100%;
`;

const SharingOptionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export default function SharingOptions({businessName,title,cardUrl,style}){

    //pass the card title
    //pass the businessname
    //needs to know the url of the card 
    
    //option 1: save the card url in clientinfo and pass the value here , set link prop only if clientInfo.url is initialized
    
    //option 2: use a guard clause (window may be not defined due to srr) and set the link only if running on client
    //by using this option there's no need to save any data or making updates once the domain name of the card changes
    
    //option 3: the component should be dumb , hence why should it deal with guard clauses?
    //use the following props: businessName,title,url
    //create a container component that will read businessName and title from the store and if the code is running on the client will get the url
    //so the guard clause will be at the parent 
    //in the dumb component we can set the link prop only if the url prop is passed

    //option 4: at start up in the card entry point you can use the guard clause and set the url in the store from the window object , then read this value later
    //in the container
    const shareUrl = (typeof window !== "undefined") ? window.location.href : null;
    return (
       // background-color: #0e0d0d; 
        <ShareContainer>
            <b><p style={{color:'white',textAlign:'center',marginTop:'25px' }}><u>{title}</u></p></b>
            <SharingOptionsContainer>
                {/* <RoundButton color={'#4FCE5D'} icon={icons['whatsapp']} link={cardUrl ? cardUrl : null}/>
                <RoundButton color={'#3b5998'} icon={icons['facebook']} link={cardUrl ? cardUrl : null}/>
                <RoundButton color={'#D44638'} icon={icons['envelopeO']} link={cardUrl ? cardUrl : null}/> */}
                <EmailShareButton url={shareUrl}>
                    <EmailIcon size={32} bgStyle={{ fill: '#D44638' }} round/>
                </EmailShareButton>
                <FacebookShareButton url={shareUrl}>
                    <FacebookIcon size={32} round/>
                </FacebookShareButton>
                <WhatsappShareButton url={shareUrl}>
                    <WhatsappIcon size={32} round/>    
                </WhatsappShareButton>
                <TelegramShareButton url={shareUrl}>
                    <TelegramIcon size={32} round/>
                </TelegramShareButton>
            </SharingOptionsContainer>
            <QRCode value={shareUrl} />
        </ShareContainer>
    );
}